package com.milta.feature.aicredit.domain.usecase

import com.milta.core.network.PagedResult
import com.milta.feature.aicredit.domain.entity.AdminAccountAiCredit
import com.milta.feature.aicredit.domain.entity.AdminAiCredit
import com.milta.feature.aicredit.domain.entity.AdminAiCreditHistoryEntry
import com.milta.feature.aicredit.domain.entity.AiCredit
import com.milta.feature.aicredit.domain.entity.AiCreditHistoryEntry
import com.milta.feature.aicredit.domain.entity.AiCreditSettings
import com.milta.feature.aicredit.domain.repository.AiCreditRepository

// MIL-98 — one use case per endpoint, same split as the MIL-97 optimization counter.

class GetMyAiCreditUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(): Result<AiCredit> = repository.getMyCredit()
}

class GetMyAiCreditHistoryUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(page: Int, pageSize: Int): Result<PagedResult<AiCreditHistoryEntry>> =
        repository.getMyHistory(page, pageSize)
}

class GetAiCreditSettingsUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(): Result<AiCreditSettings> = repository.getSettings()
}

class UpdateAiCreditSettingsUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(settings: AiCreditSettings): Result<AiCreditSettings> = repository.updateSettings(settings)
}

class GetAccountAiCreditUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(accountId: String): Result<AdminAccountAiCredit> = repository.getAccountCredit(accountId)
}

class GetAccountAiCreditHistoryUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(accountId: String, page: Int, pageSize: Int): Result<PagedResult<AdminAiCreditHistoryEntry>> =
        repository.getAccountHistory(accountId, page, pageSize)
}

class ReplaceRemainingAiCreditUseCase(private val repository: AiCreditRepository) {
    suspend operator fun invoke(accountId: String, remainingEur: Double): Result<AdminAiCredit> =
        repository.replaceRemaining(accountId, remainingEur)
}
